import { render } from "./LoginAndSignupModal.vue?vue&type=template&id=7e20aec1&scoped=true"
import script from "./LoginAndSignupModal.vue?vue&type=script&lang=js"
export * from "./LoginAndSignupModal.vue?vue&type=script&lang=js"

import "./LoginAndSignupModal.vue?vue&type=style&index=0&id=7e20aec1&scoped=true&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e20aec1"]])

export default __exports__